/** Recent searches v2 — max 4, params-dedupe, removable, account-scoped.
 * Guests: localStorage only. Logged-in: server is the source of truth
 * (useRecentSearches hook) — NO migration between scopes (User-Brief). */
const MAX = 4;

const keyFor = (scope) => `da_recent_searches_v2:${scope || "guest"}`;

const VIEW_KEYS = new Set(["quality", "sort", "limit", "cursor", "page", "location_label"]);

export function entryId(vertical, params) {
  const clean = {};
  Object.keys(params || {}).sort().forEach((k) => {
    const v = params[k];
    if (v !== null && v !== undefined && v !== "" && !VIEW_KEYS.has(k)) clean[k] = v;
  });
  const raw = JSON.stringify({ v: vertical, p: clean });
  let h = 0;
  for (let i = 0; i < raw.length; i += 1) h = ((h << 5) - h + raw.charCodeAt(i)) | 0;
  return `h${Math.abs(h)}`;
}

export function listRecentSearches(scope) {
  try {
    const raw = localStorage.getItem(keyFor(scope));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function saveRecentSearch(entry, scope) {
  // entry: { label, vertical, params }
  if (!entry || !entry.label || !entry.vertical) return listRecentSearches(scope);
  const id = entryId(entry.vertical, entry.params || {});
  const next = [
    { ...entry, id, ts: Date.now() },
    ...listRecentSearches(scope).filter((r) => r.id !== id),
  ].slice(0, MAX);
  try {
    localStorage.setItem(keyFor(scope), JSON.stringify(next));
  } catch {
    /* private mode */
  }
  return next;
}

export function removeRecentSearch(id, scope) {
  const next = listRecentSearches(scope).filter((r) => r.id !== id);
  try {
    localStorage.setItem(keyFor(scope), JSON.stringify(next));
  } catch {
    /* private mode */
  }
  return next;
}
